import {emitter} from "@/infrastructure/event_bus.js";
import {io} from "socket.io-client";
import {SOCKETIO_URL} from "@/infrastructure/urls.js";

let socket_connection = null;

function connect(token) {
    if (!token || !SOCKETIO_URL) return;
    socket_connection = io(SOCKETIO_URL, {
        auth: {
            Bearer: token
        },
        transports: ['websocket']
    });

    socket_connection.on('connect', () => {
        console.log('Успешное подключение к Socket.IO');
    });

    socket_connection.on('error', (err) => {
        console.error('Ошибка при работе с Socket.IO:', err);
    });

    socket_connection.on('event', (event) => {
        console.error('Получено событие от сервера:', event);
        emitter.emit('socketEvent', event)
    });

    socket_connection.onAny((eventName, args) => {
        console.log('Получено событие:', eventName, args);
        emitter.emit('socketEvent', {
            type: eventName,
            payload: args
        })
    });

}

function disconnect() {
    if (socket_connection === null) return;
    socket_connection.disconnect();
    socket_connection = null
}

export function initSocketListener() {
    emitter.on("newTokenIsSet", token => {
        disconnect()
        connect(token)
    })
}


